// JsFromRoutes CacheKey 1b60972f1aa69135e1caca2c2ce2ffe4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/posts/:post_id/targets'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:org_nano_id/posts/:post_id/targets/:id'),
}
